// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_publication_model from "./web_publication_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Option from "melange/option.js";

function child(source) {
  return Signal.map((function (p) {
    return Stdlib__Option.fold(false, (function (c) {
      return c.branch_only;
    }), p.control);
  }), source);
}

function editor(model, source, send) {
  const branch_only = child(source);
  const partial_arg = {
    TAG: /* Publication */ 45,
    _0: /* Retry */ 5
  };
  const partial_arg$1 = (function (param) {
    return Lui_elements.press(send, partial_arg, param);
  });
  const partial_arg$2 = "outline";
  const partial_arg$3 = "Retry same publication";
  const partial_arg$4 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$5 = Signal.map((function (p) {
    if (p.denied) {
      return false;
    } else {
      return Stdlib__Option.fold(false, (function (a) {
        return a.phase === /* Uncertain */ 1;
      }), p.attempt);
    }
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___001_) {
      const partial_arg = (function (param) {
        return Lui_elements.on_input(send, (function (text) {
          return {
            TAG: /* Publication */ 45,
            _0: {
              TAG: /* Title */ 0,
              _0: text
            }
          };
        }), param);
      });
      const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (p) {
        return !p.initialized;
      }), source)));
      const partial_arg$2 = "Publication title";
      const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (p) {
        return p.title;
      }), source)));
      return function (param, param$1) {
        return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___002_) {
        const partial_arg = (function (param) {
          return Lui_elements.on_input(send, (function (text) {
            return {
              TAG: /* Publication */ 45,
              _0: {
                TAG: /* Body */ 1,
                _0: text
              }
            };
          }), param);
        });
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
          return !p.initialized;
        }), source)));
        const partial_arg$2 = "Publication description";
        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
          return p.body;
        }), source)));
        return function (param, param$1) {
          return Lui_elements.textarea(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___003_) {
          const partial_arg = {
            TAG: /* Publication */ 45,
            _0: /* Submit */ 3
          };
          const partial_arg$1 = (function (param) {
            return Lui_elements.press(send, partial_arg, param);
          });
          const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (p) {
            return !Mapre_web__Web_publication_model.can_submit(p);
          }), source)));
          const partial_arg$3 = "primary";
          const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (child) {
            if (child) {
              return "Publish child branch";
            } else {
              return "Create draft PR";
            }
          }), branch_only)));
          return function (param, param$1) {
            return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
        }),
        tl: /* [] */ 0
      }
    }
  };
  const partial_arg$6 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$7 = 0;
  const partial_arg$8 = 8;
  const partial_arg$9 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, param, param$1);
  };
  const partial_arg$10 = Signal.map(Mapre_web__Web_model.can_create, model);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$10, partial_arg$9, param, param$1);
  };
}

function result(source) {
  const pr = Signal.map((function (p) {
    return Stdlib__Option.bind(Stdlib__Option.bind(p.control, (function (c) {
      return c.publication;
    })), (function (publication) {
      return publication.pr;
    }));
  }), source);
  const partial_arg = Signal.map((function (value) {
    return value !== undefined;
  }), pr);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg, (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___004_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (param) {
          return Stdlib__Option.fold("View PR", (function (p) {
            return "View PR #" + String(p.number);
          }), param);
        }), pr)));
        const partial_arg$1 = "blank";
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (param) {
          return Stdlib__Option.fold("https://github.com/", (function (p) {
            return p.url;
          }), param);
        }), pr)));
        return function (param, param$1) {
          return Lui_elements.link(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }), param, param$1);
  };
}

function branch_result(source) {
  const published = Signal.map((function (p) {
    return Stdlib__Option.bind(p.control, (function (c) {
      return c.publication;
    }));
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___005_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (p) {
        if (p !== undefined) {
          return "Branch: " + p.branch;
        } else {
          return "";
        }
      }), published)));
      return function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___006_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (p) {
          if (p !== undefined) {
            return "Commit: " + Stdlib__Option.value(p.commit, "");
          } else {
            return "";
          }
        }), published)));
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$1 = 4;
  const partial_arg$2 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
  };
  const partial_arg$3 = Signal.map((function (p) {
    if (p !== undefined && p.phase === "complete" && Caml_obj.caml_equal(p.receipt_state, "pushed")) {
      return p.pr === undefined;
    } else {
      return false;
    }
  }), published);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$3, partial_arg$2, param, param$1);
  };
}

function stop_control(model, source, send) {
  const partial_arg = Signal.map((function (m) {
    if (Mapre_web__Web_model.can_create(m)) {
      return Stdlib__Option.fold(false, (function (c) {
        return c.can_stop;
      }), m.publication.control);
    } else {
      return false;
    }
  }), model);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg, (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___007_) {
        const partial_arg = {
          TAG: /* Publication */ 45,
          _0: /* Stop */ 4
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (p) {
          return Stdlib__Option.fold(true, (function (c) {
            return c.stop_requested;
          }), p.control);
        }), source)));
        const partial_arg$3 = "outline";
        const partial_arg$4 = "Stop sandbox";
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }), param, param$1);
  };
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return m.publication;
  }), model);
  const partial_arg = "Review and publish";
  const partial_arg$1 = 2;
  const partial_arg$2 = Signal.map((function (p) {
    return p.message !== "";
  }), source);
  const partial_arg$3 = editor(model, source, send);
  const partial_arg$4 = Signal.map((function (p) {
    return Stdlib__Option.fold(true, (function (c) {
      return c.publication === undefined;
    }), p.control);
  }), source);
  const partial_arg$5 = "Sandbox stopped; conversation retained.";
  const partial_arg$6 = "muted";
  const partial_arg$7 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$8 = Signal.map((function (p) {
    return Stdlib__Option.fold(false, (function (c) {
      return c.cleanup === "stopped";
    }), p.control);
  }), source);
  const partial_arg$9 = Signal.map((function (p) {
    return Stdlib__Option.bind(p.control, (function (c) {
      return c.failure;
    })) !== undefined;
  }), source);
  const partial_arg$10 = {
    TAG: /* Publication */ 45,
    _0: /* Refresh */ 2
  };
  const partial_arg$11 = (function (param) {
    return Lui_elements.press(send, partial_arg$10, param);
  });
  const partial_arg$12 = "outline";
  const partial_arg$13 = "Refresh publication";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___008_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map(Mapre_web__Web_publication_model.progress, source)));
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$2, (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___009_) {
            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map((function (p) {
              return p.message;
            }), source)));
            const partial_arg$1 = "notice";
            return function (param, param$1) {
              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }), param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$4, partial_arg$3, param, param$1);
        }),
        tl: {
          hd: stop_control(model, source, send),
          tl: {
            hd: result(source),
            tl: {
              hd: branch_result(source),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.if_(partial_arg$8, partial_arg$7, param, param$1);
                }),
                tl: {
                  hd: (function (param, param$1) {
                    return Lui_elements.if_(partial_arg$9, (function (param, param$1) {
                      return Lui_elements.scoped((function (__lui_context___010_) {
                        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___010_.ui_scope, Signal.map((function (p) {
                          return "Publication stopped: " + Stdlib__Option.value(Stdlib__Option.bind(p.control, (function (c) {
                            return c.failure;
                          })), "");
                        }), source)));
                        const partial_arg$1 = "notice";
                        return function (param, param$1) {
                          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                        };
                      }), param, param$1);
                    }), param, param$1);
                  }),
                  tl: {
                    hd: (function (param, param$1) {
                      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                    }),
                    tl: /* [] */ 0
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$14 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$15 = "form-card";
  const partial_arg$16 = 0;
  const partial_arg$17 = 16;
  const partial_arg$18 = 10;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
